module.exports = __webpack_public_path__ + "static/media/confident.0d72cd76.gif";